module.exports = __webpack_public_path__ + "static/media/bottom_banner_10_2.4fb0042f.png";